module.exports = __webpack_public_path__ + "assets/discount_black-a047e4.svg";